import { StrictMode } from 'react'
import { createRoot, Root } from 'react-dom/client'
import Form from './Form.tsx'
import { createIsolatedFormStore } from './redux/formStore.ts'
import { Provider as ReduxProvider } from 'react-redux'
import { FormAppRelayInterface } from '@fusion-advantage/backcompat'
import { setFormAppRelay } from './lib/relay/FormAppRelay.ts'
import { AppFormRelayImpl } from './lib/relay/AppFormRelay.ts'
import { loadFontAwesomeLibrary } from './icons.ts'
import { library } from '@fortawesome/fontawesome-svg-core'

loadFontAwesomeLibrary(library)

export interface CreateFormRendererProps {
	el: HTMLElement
	formAppRelay: FormAppRelayInterface
}

export interface FormRenderer {
	root: Root
	appFormRelay: AppFormRelayImpl
}

export const createFormRenderer = ({el, formAppRelay}: CreateFormRendererProps): FormRenderer => {
	setFormAppRelay(formAppRelay)
	const formStore = createIsolatedFormStore()
	const root = createRoot(el)
	root.render(
		<StrictMode>
			<ReduxProvider store={formStore}>
				<Form />
			</ReduxProvider>
		</StrictMode>,
	)
	return {
		root,
		appFormRelay: new AppFormRelayImpl(formStore),
	}
}
